/**
 * EVT-06: the member-verification numbers on the MSR Overview, from get_event_attribution_summary (the same read the
 * Attendees tab's "Verify member sign-ups" section shows). Pure so it is unit-tested.
 *   verified = sign-ups credited to a rep (with one rep on the event, every pooled sign-up counts automatically);
 *   pending  = pooled sign-ups not yet credited to anyone: counted from the pool rows (already_attributed = false)
 *              when they are loaded; until then pool minus verified, never below zero (verified can include credit
 *              from outside the pool, so that fallback can undercount -- internal audit P3-9).
 */
export interface VerificationSummaryInput {
  total_pool?: number | null;
  total_verified?: number | null;
  single_rep_auto?: boolean | null;
}

export function verificationCounts(
  sum: VerificationSummaryInput | null | undefined,
  poolRows?: { already_attributed?: boolean | null }[] | null,
): { verified: number; pending: number; signups: number; auto: boolean } {
  const signups = Math.max(0, Number(sum?.total_pool ?? 0) || 0);
  const verified = Math.max(0, Number(sum?.total_verified ?? 0) || 0);
  const auto = sum?.single_rep_auto === true;
  let pending = Math.max(0, signups - verified);
  if (poolRows) {
    pending = poolRows.filter((r) => r.already_attributed !== true).length;
  }
  if (auto) {
    pending = 0;
  }
  return { signups, verified, pending, auto };
}
